import { tss } from 'tss-react/mui';

export const usePositioningStyles = tss.withName('PositioningSection').create(({ theme }) => ({
    section: {
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(18, '6%'),
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(10, '6%'),
        },
    },
    inner: {
        maxWidth: 900,
        margin: '0 auto',
        textAlign: 'center',
    },
    statement: {
        color: theme.palette.text.primary,
    },
}));
